import type { FaireProductEntity } from "../../entity_types/product";

export const p_r32k4kudcs: FaireProductEntity = {
  token: "p_r32k4kudcs",
  type: "product",
  name: "Black Cat Spell Books Figurine",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/6e9a0a69222caead6eaa6fc4e50c9b39883780db9238e6e20b18d5154b888d7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/24be80598983e187b4043ce1cb18d79868faf7497d709686c4e382460b91dbc8.jpeg",
    "https://cdn.faire.com/fastly/85763083435b06701a13e7afd6d195460e7d25e4e1e56e51232203bd28c0eb90.jpeg",
    "https://cdn.faire.com/fastly/302224110208cd4c9531bbc944d0474c53aa2f984b8e054b657e0474c736858e.jpeg"
  ],
  priceDollars: 10,
  description: "A decorative figurine from our Halloween Collection featuring a fun witch inspired design that coordinates well with witchy home decor and seasonal Halloween displays. This witch figurine displays a cute black cat sitting on a stack of spell books with one titled \"Black Cat Magic.\" Our Black Cat Spell Books figurine is designed to free stand on flat surface to easily add personality to any home or work space. For decorative use only; this is not a toy. A Halloween home accent perfect for seasonal displays or for everyday witch themed decor.",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:25.134Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
